(function() {
    if (window.driiveRewardsGlobalInitialized) return;
    window.driiveRewardsGlobalInitialized = true;

    console.log("[Driive Rewards] Script Initialized (v10.2.1 - Points NaN Fix)");

    // --- Global State & Config ---
    let driiveConfig = {};
    let lastKnownCartTotal = -1;
    let isFetchInProgress = false;
    let currentUserState = 'INITIALIZING';
    let lastSuccessfulResult = null; 

    // --- CSS Injection ---
    const injectCSS = () => {
        const styleId = 'driive-rewards-styles';
        if (document.getElementById(styleId)) return;
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
            .driive-prompt-container { padding: 15px; border: 1px solid #e1e1e1; border-radius: 5px; text-align: center; background-color: #f9f9f9; margin: 10px 0; }
            .driive-prompt-container p { margin: 0 0 10px 0; font-size: 14px; color: #333; }
            .driive-prompt-button { display: inline-block; padding: 10px 20px; background-color: #000; color: #fff; border: none; border-radius: 5px; cursor: pointer; font-size: 14px; text-decoration: none; transition: background-color 0.2s; }
            .driive-prompt-button:hover { background-color: #333; }
        `;
        document.head.appendChild(style);
    };

    const syncContainer = (container) => {
        if (!container) return;
        let content = '';
        switch (currentUserState) {
            case 'LOGGED_OUT':
                content = `<div class="driive-prompt-container"><p>Log in to check for rewards.</p><a href="/account/login" class="driive-prompt-button">Login or Sign Up</a></div>`;
                break;
            case 'NEEDS_ADDRESS':
                content = `<div class="driive-prompt-container"><p>Please add an address to check for rewards.</p><a href="/account/addresses" class="driive-prompt-button">Add Address & Phone</a></div>`;
                break;
            case 'NEEDS_PHONE':
                content = `<div class="driive-prompt-container"><p>Please add a phone number to your address.</p><a href="/account/addresses" class="driive-prompt-button">Add Phone Number</a></div>`;
                break;
            case 'READY':
                if (isFetchInProgress) {
                    content = `<p>Checking for rewards...</p>`;
                } else if (lastSuccessfulResult) {
                    renderRewardsUI(container, lastSuccessfulResult);
                    return;
                } else {
                    content = `<p>Checking for rewards...</p>`;
                }
                break;
            default:
                content = `<p>Initializing...</p>`;
        }
        container.innerHTML = content;
        container.dataset.driiveInitialized = 'true';
    };

    const updateAllUIs = () => {
        document.querySelectorAll('.driive-rewards-container').forEach(syncContainer);
    };

    const fetchRewards = async () => {
        if (isFetchInProgress) return;
        isFetchInProgress = true;
        updateAllUIs(); 

        try {
            const cart = await getCart();
            lastKnownCartTotal = cart.total_price;
            const cartTotal = parseFloat(cart.total_price / 100);
            
            const url = `${driiveConfig.proxyUrl}?phone=${encodeURIComponent(driiveConfig.customerPhone)}&shop=${encodeURIComponent(driiveConfig.shopDomain)}&cart_total=${cartTotal}`;
            
            const response = await fetch(url);
            const result = await response.json();
            
            if (result.success && result.rewards && result.rewards.length > 0) {
                result.rewards = result.rewards.filter(reward => {
                    const minPurchase = parseFloat(reward.min_purchase_amount || 0);
                    return cartTotal >= minPurchase;
                });
            }
            
            lastSuccessfulResult = { state: 'LOADED', ...result };

        } catch (error) {
            console.error("[Driive Rewards] Fetch error:", error);
            lastSuccessfulResult = { state: 'ERROR', error: "Error checking rewards." };
        } finally {
            isFetchInProgress = false;
            updateAllUIs();
        }
    };

    const renderRewardsUI = (container, result) => {
        if (!result.rewards || result.rewards.length === 0) {
            let content = `<p>No available rewards found for your account.</p>`;
            // Still show points balance if available
            if (result.point_balance !== null) {
                content += renderPointsBalance(result);
            }
            container.innerHTML = content;
            return;
        }

        const firstReward = result.rewards[0];
        const rewardValue = parseFloat(firstReward.value).toFixed(2);
        const expirationDate = new Date(firstReward.expirationdate).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
        
        let rewardsHtml = `
            <div class="driive-main-reward" style="padding: 10px; border: 1px solid #ddd; border-radius: 5px;">
                <div class="driive-reward-details">
                    <span style="font-weight: bold;">${firstReward.description} - $${rewardValue}</span><br>
                    <span style="font-size: 0.9em; color: #555;">Expires: ${expirationDate}</span>
                </div>
            </div>
        `;

        if (result.rewards.length > 1) {
            rewardsHtml += `
                <select class="driive-rewards-dropdown" style="width: 100%; margin-top: 10px; padding: 8px;">
                    ${result.rewards.map(reward => `<option value="${reward.rewardcode}" data-reward-value="${reward.value}">${reward.description} - $${parseFloat(reward.value).toFixed(2)}</option>`).join('')}
                </select>
            `;
        }

        container.innerHTML = rewardsHtml;

        const redeemButton = document.createElement('button');
        redeemButton.className = 'driive-redeem-button';
        redeemButton.textContent = 'Redeem';
        redeemButton.style.cssText = 'width: 100%; margin-top: 10px; padding: 12px; background-color: #000; color: #fff; border: none; border-radius: 5px; cursor: pointer; font-size: 16px;';
        container.appendChild(redeemButton);
        
        const updateButtonData = () => {
            let selectedReward;
            if (result.rewards.length > 1) {
                const dropdown = container.querySelector('.driive-rewards-dropdown');
                const selectedCode = dropdown.value;
                selectedReward = result.rewards.find(r => r.rewardcode === selectedCode);
            } else {
                selectedReward = firstReward;
            }
            if (selectedReward) {
                redeemButton.dataset.rewardCode = selectedReward.rewardcode;
                redeemButton.dataset.rewardValue = selectedReward.value;
                redeemButton.dataset.g3mid = result.g3mid;
            }
        };

        if (result.rewards.length > 1) {
            container.querySelector('.driive-rewards-dropdown').addEventListener('change', updateButtonData);
        }
        redeemButton.addEventListener('click', redeemReward);
        updateButtonData();

        if (result.point_balance !== null) {
            container.insertAdjacentHTML('beforeend', renderPointsBalance(result));
        }
    };

    /**
     * Generates the HTML string for the points balance summary.
     */
    const renderPointsBalance = (result) => {
        // FIX: Provide a fallback of 0 if point_balance is null, undefined, or not a number.
        const pointsBalance = parseInt(result.point_balance, 10) || 0;
        
        // FIX: Provide a sensible default for points_needed if it's missing from the API response.
        const pointsNeeded = parseInt(result.points_needed_for_reward, 10) || 250; 
        
        const pointsRemaining = pointsNeeded - pointsBalance;
        
        let pointsMessage = `You have <strong>${pointsBalance}</strong> points.`;

        // This condition will now work correctly even with 0 points.
        if (pointsRemaining > 0 && pointsBalance < pointsNeeded) {
            pointsMessage += `<br>Only <strong>${pointsRemaining}</strong> points until your next reward!`;
        } else {
            pointsMessage += `<br>You have enough points for a new reward!`;
        }
        return `
            <div class="driive-points-summary" style="margin-top: 20px; padding: 15px; border: 1px solid #ddd; border-radius: 5px; text-align: center;">
                ${pointsMessage}
            </div>
        `;
    };

    const redeemReward = async (event) => {
        const redeemBtn = event.currentTarget;
        const { rewardCode, rewardValue, g3mid } = redeemBtn.dataset;
        redeemBtn.disabled = true;
        redeemBtn.textContent = "Redeeming...";
        try {
            const response = await fetch(driiveConfig.proxyUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ shop: driiveConfig.shopDomain, amount: rewardValue, g3mid: g3mid, reward_code: rewardCode })
            });
            const data = await response.json();
            if (response.ok && data.success && data.discount_code) {
                window.location.href = `/checkout?discount=${data.discount_code}`;
            } else {
                alert(`Failed to redeem: ${data.error || 'Unknown error'}`);
                redeemBtn.disabled = false;
                redeemBtn.textContent = "Redeem";
            }
        } catch (error) {
            console.error("[Driive Rewards] Redeem error:", error);
            alert("Could not redeem reward due to a technical issue.");
            redeemBtn.disabled = false;
            redeemBtn.textContent = "Redeem";
        }
    };
    
    const getCart = async () => (await fetch('/cart.js')).json();
    
    const init = () => {
        injectCSS();
        driiveConfig = window.driiveRewardsConfig || {};

        if (!driiveConfig.shopDomain) {
            setTimeout(init, 200);
            return;
        }

        if (!driiveConfig.isLoggedIn) {
            currentUserState = 'LOGGED_OUT';
        } else if (!driiveConfig.customerHasAnyAddress) {
            currentUserState = 'NEEDS_ADDRESS';
        } else if (!driiveConfig.customerPhone) {
            currentUserState = 'NEEDS_PHONE';
        } else {
            currentUserState = 'READY';
        }
        console.log("[Driive Rewards] Initial state determined:", currentUserState);

        document.querySelectorAll('.driive-rewards-container').forEach(syncContainer);
        if (currentUserState === 'READY') {
            fetchRewards();
        }

        const checkForUpdates = async () => {
            document.querySelectorAll('.driive-rewards-container:not([data-driive-initialized="true"])').forEach(container => {
                console.log("[Driive Rewards] New container detected via polling. Syncing.");
                syncContainer(container);
            });

            if (currentUserState !== 'READY' || isFetchInProgress) return;
            try {
                const cart = await getCart();
                if (cart.total_price !== lastKnownCartTotal) {
                    console.log("[Driive Rewards] Cart total changed. Re-fetching rewards.");
                    fetchRewards();
                }
            } catch(e) { console.error("[Driive Rewards] Error checking for cart updates:", e); }
        };
        setInterval(checkForUpdates, 1500); 
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
